export default "__VITE_ASSET__xPYl3edA__"